import React from "react";
import Card from "react-bootstrap/Card";

const SummaryCard = props => {
  const bodyIconClass = `border rounded-circle px-2 bg-light h1 ${props.icon}`;

  return (
    <Card className="m-1 border rounded">
      <Card.Body className="align-items-center">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-sm-auto">
              <i className={bodyIconClass}></i>
            </div>
            <div className="col" align="right">
              {props.bodyText}
              <br />
              <span className="h2">{props.value}</span>
            </div>
          </div>
        </div>
      </Card.Body>
      <Card.Footer>
        <i className={props.icon}></i>
        <small className="text-muted"> {props.footerText}</small>
      </Card.Footer>
    </Card>
  );
};

export default SummaryCard;
